import { render } from "./RecaptchaGate.vue?vue&type=template&id=67d56aae&scoped=true"
import script from "./RecaptchaGate.vue?vue&type=script&lang=js"
export * from "./RecaptchaGate.vue?vue&type=script&lang=js"

import "./RecaptchaGate.vue?vue&type=style&index=0&id=67d56aae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d56aae"]])

export default __exports__